module.exports = __webpack_public_path__ + "files/0b8a3f93d7e3c3c4c3d2f8e35e6be918.png";